import React, { useState, useCallback } from "react";
import { AnimatePresence } from 'framer-motion';
import "../../assets/css/modalgallery.css";


import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import { photos } from "./photos";
  
function ModalGallery() {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };
  return (
		 <> 
	     <h1><span className="color1">M</span><span className="color2">P</span><span className="color3">S</span><span className="color4"> Gallery </span> </h1>	  
	 <div className="modalGallery">
		
      <Gallery photos={photos} onClick={openLightbox} />
	  
      <ModalGateway>
	  
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
		    <AnimatePresence>			
            <Carousel			  
              currentIndex={currentImage}
              views={photos.map(x => ({
                ...x,
                srcset: x.srcSet,
                caption: x.title
              }))}
            />
			</AnimatePresence>
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
	</>
  );
}

export default ModalGallery;
